import HayChair from '../images/seating/About-A-Chair-AAC-222.png';
import HayChair1 from '../images/seating/About-A-Chair-AAC-222-1.jpg';
import PetraChair from '../images/seating/Petra-VB3-Lounge-Chair.png';
import PetraChair1 from '../images/seating/Petra-VB3-Lounge-Chair-1.jpeg';
import PetraChair2 from '../images/seating/Petra-VB3-Lounge-Chair-2.jpeg';
import Loafer from '../images/seating/Loafer-SC23-Lounge-Chair.png';
import Loafer1 from '../images/seating/Loafer-SC23-Lounge-Chair-1.jpeg';
import Loafer2 from '../images/seating/Loafer-SC23-Lounge-Chair-2.png';
import Xchair from '../images/seating/X-Lounge-Chair-HM10.png';
import Xchair1 from '../images/seating/X-Lounge-Chair-HM10-1.png';
import Xchair2 from '../images/seating/X-Lounge-Chair-HM10-2.png';
import FranceChairBrown from '../images/seating/France-Chair-brown.png';
import FranceChairBrown2 from '../images/seating/France-Chair-brown-2.png';
import FanceChairBlack from '../images/seating/France-Chair-black.png';
import FanceChairBlack2 from '../images/seating/France-Chair-black-2.png';
import InlandBrown from '../images/seating/Inland-AV21-Lounge-Chair-Noble-Cognac-Leather.png';
import InlandBrown1 from '../images/seating/Inland-AV21-Lounge-Chair-Noble-Cognac-Leather-1.jpg';
import InlandBrown2 from '../images/seating/Inland-AV21-Lounge-Chair-Noble-Cognac-Leather-2.jpg';
import InlandBlue from '../images/seating/Inland-AV21-Lounge-Chair-Vidar-733.png';
import InlandBlue1 from '../images/seating/Inland-AV21-Lounge-Chair-Vidar-733-1.jpg';
import InlandBlue2 from '../images/seating/Inland-AV21-Lounge-Chair-Vidar-733-2.jpg';
import InlandClay from '../images/seating/Inland-AV21-Lounge-Chair-Clay-0011.png';
import InlandClay1 from '../images/seating/Inland-AV21-Lounge-Chair-Clay-0011-1.jpg';
import InlandClay2 from '../images/seating/Inland-AV21-Lounge-Chair-Clay-0011-2.jpg';
import MargasSofa from '../images/seating/Margas-LC4.png';
import MargasSofa1 from '../images/seating/Margas-LC4-1.jpeg';
import MargasSofa2 from '../images/seating/Margas-LC4-2.jpeg';
import MayorSofa from '../images/seating/Mayor-AJ6.png';
import MayorSofa1 from '../images/seating/Mayor-AJ6-1.jpeg';
import MayorSofa2 from '../images/seating/Mayor-AJ6-2.jpeg';
import ShuffleTable from '../images/tables/Shuffle-Table-MH1.png';
import ShuffleTable1 from '../images/tables/Shuffle-Table-MH1-1.webp';
import ShuffleTable2 from '../images/tables/Shuffle-Table-MH1-2.webp';
import RotateTable from '../images/tables/Rotate-Table-SC73.png';
import RotateTable1 from '../images/tables/Rotate-Table-SC73-2.jpeg';
import RotateTable2 from '../images/tables/Rotate-Table-SC73-3.webp';
import PaletteDesk from '../images/tables/Palette-JH9-Desk.png';
import PaletteDesk1 from '../images/tables/Palette-JH9-Desk-1.jpeg';
import PaletteDesk2 from '../images/tables/Palette-JH9-Desk-2.jpeg';
import TungTable from '../images/tables/Tung-JA3-Side-Table.png';
import TungTable1 from '../images/tables/Tung-JA3-Side-Table-1.jpeg';
import TungTable2 from '../images/tables/Tung-JA3-Side-Table-2.jpeg';
import PavilionDesk from '../images/tables/Pavilion-AV17-desk.png';
import PavilionDesk1 from '../images/tables/Pavilion-AV17-desk-2.jpg';
import PavilionDesk2 from '../images/tables/Pavilion-AV17-desk-3.jpg';
import FlowerpotY from '../images/lighting/Flowerpot-VP9-mustard.png';
import FlowerpotY1 from '../images/lighting/Flowerpot-VP9-mustard-1.png';
import FlowerpotB from '../images/lighting/Flowerpot-VP9-cobalt-blue.png';
import FlowerpotB1 from '../images/lighting/Flowerpot-VP9-cobalt-blue-1.png';
import FlowerpotR from '../images/lighting/Flowerpot-VP9-vermillion-red.png';
import FlowerpotR1 from '../images/lighting/Flowerpot-VP9-vermillion-red-1.png';
import FlowerpotR2 from '../images/lighting/Flowerpot-VP9-vermillion-red-2.webp';
import JH5 from '../images/lighting/Formakami-JH5.png';
import JH5_1 from '../images/lighting/Formakami-JH5-1.webp';
import JH5_2 from '../images/lighting/Formakami-JH5-2.png';
import JH3 from '../images/lighting/Formakami-JH3.png';
import JH3_1 from '../images/lighting/Formakami-JH3-1.webp';
import JH3_2 from '../images/lighting/Formakami-JH3-2.webp';
import MeridianLampB from '../images/lighting/Meridian-Lamp-black.png';
import MeridianLampB1 from '../images/lighting/Meridian-Lamp-black-1.png';
import MeridianLampB2 from '../images/lighting/Meridian-Lamp-black-2.png';
import MeridianLampC from '../images/lighting/Meridian-Lamp-cashmere.png';
import MeridianLampC1 from '../images/lighting/Meridian-Lamp-cashmere-1.png';
import MeridianLampC2 from '../images/lighting/Meridian-Lamp-cashmere-2.png';
import ArumLamp from '../images/lighting/Arum-Floor-Lamp.png';
import ArumLamp1 from '../images/lighting/Arum-Floor-Lamp-1.webp';
import SetgoLamp from '../images/lighting/Setgo-Lamp.png';
import SetgoLamp1 from '../images/lighting/Setgo-Lamp-1.png';
import SetgoLamp2 from '../images/lighting/Setgo-Lamp-2.jpeg';
import Flowerpot from '../images/lighting/Flowerpot-VP12.png';
import Flowerpot1 from '../images/lighting/Flowerpot-VP12-1.jpeg';
import Flowerpot2 from '../images/lighting/Flowerpot-VP12-2.jpeg';
import Pandent from '../images/lighting/P376-KF1-Pandent-Light.png';
import Pandent1 from '../images/lighting/P376-KF1-Pandent-Light-1.jpeg';
import Pandent2 from '../images/lighting/P376-KF1-Pandent-Light-2.jpeg';
import MomentoB from '../images/objects/Momento-Throw-JH46-blue.png';
import MomentoB1 from '../images/objects/Momento-Throw-JH46-blue-1.jpeg';
import MomentoB2 from '../images/objects/Momento-Throw-JH46-blue-2.jpeg';
import MomentoR from '../images/objects/Momento-Throw-JH46-red.png';
import MomentoR1 from '../images/objects/Momento-Throw-JH46-red-1.jpeg';
import MomentoR2 from '../images/objects/Momento-Throw-JH46-red-2.jpeg';
import Framed from '../images/objects/Framed-AP14.png';
import Framed1 from '../images/objects/Framed-AP14-1.jpeg';
import Framed2 from '../images/objects/Framed-AP14-2.jpeg';
import Moor from '../images/objects/The-Moor-AP18.png';
import Moor1 from '../images/objects/The-Moor-AP18-1.jpeg';
import Moor2 from '../images/objects/The-Moor-AP18-2.jpeg';
import JH41 from '../images/objects/Momento-Vase-JH41.jpeg';
import JH41_1 from '../images/objects/Momento-Vase-JH41-1.jpeg';
import JH40 from '../images/objects/Momento-Vase-JH40.png';
import JH40_1 from '../images/objects/Momento-Vase-JH40-1.jpeg';
import Verso from '../images/objects/Verso-Vase-Terracotta.png';
import Verso1 from '../images/objects/Verso-Vase-Terracotta-1.png';
import Verso2 from '../images/objects/Verso-Vase-Terracotta-2.png';
import Cara from '../images/objects/White-Cara-Clock.png';
import Cara1 from '../images/objects/White-Cara-Clock-1.png';
import Riki from '../images/objects/Riki-Steel-Clock-White.png';
import Riki1 from '../images/objects/Riki-Steel-Clock-White-1.webp';
import Jug from '../images/objects/Momento-Jug-JH38.png';
import Jug1 from '../images/objects/Momento-Jug-JH38-1.jpeg';
import Jug2 from '../images/objects/Momento-Jug-JH38-2.jpeg';
import CandleholderR from '../images/objects/Momento-Candleholder-JH39-red.png';
import CandleholderR1 from '../images/objects/Momento-Candleholder-JH39-red-1.jpeg';
import CandleholderB from '../images/objects/Momento-Candleholder-JH39-blue.png';
import CandleholderB1 from '../images/objects/Momento-Candleholder-JH39-blue-1.jpeg';
import MatinLamp from '../images/lighting/Matin-Flush-Mount-Lamp.png';
import MatinLamp1 from '../images/lighting/Matin-Flush-Mount-Lamp-1.png';
import PaoLamp from '../images/lighting/Pao-Portable-Lamp.png';
import PaoLamp1 from '../images/lighting/Pao-Portable-Lamp-1.png';
import PaoLamp2 from '../images/lighting/Pao-Portable-Lamp-2.png';

export const All_PRODUCTS_DATA = [
  {
    id: 1,
    name: 'About A Chair AAC 222',
    featured: true,
    brand: 'HAY',
    designer: 'Hee Welling',
    category: 'seating',
    type: 'lounge chair',
    img: [HayChair, HayChair1],
    color: 'Slate Blue',
    price: '440',
    description:
      'The newest model in the AAC series retains all the hallmark features of its predecessors but introduces a higher back and a deeper seat for enhanced comfort. Its frame, with elegant rounded legs, adds character and stability, and comes in various finishes. The shell is available in multiple colors and upholstery options, crafted from 100% post-consumer recycled plastic. Designed with armrests that provide excellent support, this chair fits comfortably under most dining tables and desks.',
    productDetails: 'W: 59cm, D: 54cm, H: 82cm, Seat D: 42cm, Seat H: 46.5cm',
    materials: '100% post-consumer recycled PP, lacquered walnut',
  },
  {
    id: 2,
    name: 'Petra VB3 Lounge Chair',
    featured: true,
    brand: '&Tradition',
    designer: 'Viggo Boesen',
    category: 'seating',
    type: 'lounge chair',
    img: [PetraChair, PetraChair1, PetraChair2],
    color: 'Sheepskin Moonlight & Oiled Walnut',
    price: '6500',
    description: `Petra, a lounge chair originally designed by Danish designer Viggo Boesen in 1938, features a high-set, winged backrest that offers exceptional comfort. Following the success of the Little Petra chair—named after Boesen's mother-in-law, Petra, a petite woman known for her vibrant personality—the Petra lounge chair embodies the same bold character and inviting design but in a larger size.`,
    productDetails:
      'H: 99cm, W: 80cm, D:91cm, Seat H: 40cm, Seat D: 53cm, Armrest H: 51cm',
    materials: 'wood, HR foam, polyester wadding, fabric upholstery',
  },
  {
    id: 3,
    name: 'Inland AV21 Lounge Chair',
    featured: false,
    brand: '&Tradition',
    designer: 'Anderssen & Voll',
    category: 'seating',
    type: 'lounge chair',
    img: [InlandBrown, InlandBrown1, InlandBrown2],
    color: 'Noble Cognac Leather',
    price: '6400',
    description:
      'Crafted by Torbjørn Anderssen and Espen Voll, the Inland series combines architectural elegance with comfort. Originally featuring two and three-seater sofas, the series has expanded to include a lounge chair and pouf, all characterized by inviting curves and a steel-footed base that lends a floating illusion.',
    productDetails:
      'H: 66.5cm, W: 100.4cm, D: 92.7cm, Seath H: 40cm, Seat D: 63cm',
    materials:
      'Wooden frame, upholstered with fabric or leather and warm black powder coated or polished metal legs.',
  },
  {
    id: 4,
    name: 'Loafer SC23 Lounge Chair',
    featured: true,
    brand: '&Tradition',
    designer: 'Space Copenhagen',
    category: 'seating',
    type: 'sofa',
    img: [Loafer, Loafer1, Loafer2],
    color: 'Green Velvet',
    price: '3120',
    description: `The SAS Royal Hotel enlisted Space Copenhagen founders Signe and Peter to design a chair that would complement the hotel's aesthetics and fit seamlessly into any setting. The result was the Loafer chair. “The SAS Royal Hotel lobby is a crucial element of its iconic interior,” says Peter. “It's vast and elegant, and we aimed to create a piece that would bring a sense of intimacy to this expansive space.`,
    productDetails: 'H: 75cm, W: 70cm, D: 65cm, Seat H: 42cm, Seating D: 48cm',
    materials:
      'wood, HR foam, polyester wadding, fabric & leather upholstery, black base',
  },
  {
    id: 5,
    name: 'X Lounge Chair HM10',
    featured: false,
    brand: '&Tradition',
    designer: 'Hvidt & Mølgaard',
    category: 'seating',
    type: 'lounge chair',
    img: [Xchair, Xchair1, Xchair2],
    color: 'Oak',
    price: '2375',
    description: `Exhibiting a captivating fusion of material and concept, the X lounge chair epitomizes the pinnacle of Hvidt & Mølgaard's prowess as furniture designers. Following years of experimentation with the idea of a laminated wooden frame inspired by vintage tennis rackets, the Danish design duo unveiled the X lounge chair in 1959. Characterized by its distinctive sloping silhouette and understated aesthetic, the X lounge chair remains an enduring icon of mid-century design.`,
    productDetails: 'H: 72.2cm, W: 56.6cm, D: 67.3cm, Seat H: 38.3cm',
    materials: 'Oak w. walnut insert and natural rattan seat',
  },
  {
    id: 6,
    name: 'France Chair',
    featured: false,
    brand: '&Tradition',
    designer: 'Finn Juhl',
    category: 'seating',
    type: 'lounge chair',
    img: [FranceChairBrown, FranceChairBrown2],
    color: 'brown',
    price: '7400',
    description: `The France Chair, also known as the FJ 136, was initially designed for the American market in the late 1950s, delivered flat-packed. Finn Juhl's innovative approach to knock-down furniture contributed significantly to his success. Today, it comes fully assembled.
    Finn Juhl, a leading figure in twentieth-century furniture design, introduced North America to Danish Modern. Trained as an architect, he gained renown for his organic forms and expressive woodwork, aiming to infuse furniture with movement and vitality akin to sculpture.`,
    productDetails: 'H: 81cm, W: 80cm, D: 72cm, Seat H: 38cm',
    materials: 'leather, walnut',
  },
  {
    id: 7,
    name: 'Inland AV21 Lounge Chair',
    featured: false,
    brand: '&Tradition',
    designer: 'Anderssen & Voll',
    category: 'seating',
    type: 'lounge chair',
    img: [InlandBlue, InlandBlue1, InlandBlue2],
    color: 'Vidar 733',
    price: '4900',
    description:
      'Crafted by Torbjørn Anderssen and Espen Voll, the Inland series combines architectural elegance with comfort. Originally featuring two and three-seater sofas, the series has expanded to include a lounge chair and pouf, all characterized by inviting curves and a steel-footed base that lends a floating illusion.',
    productDetails:
      'H: 66.5cm, W: 100.4cm, D: 92.7cm, Seath H: 40cm, Seat D: 63cm',
    materials:
      'Wooden frame, upholstered with fabric or leather and warm black powder coated or polished metal legs.',
  },
  {
    id: 8,
    name: 'Margas LC4',
    featured: false,
    brand: '&Tradition',
    designer: 'Louise Liljencrantz',
    category: 'seating',
    type: 'sofa',
    img: [MargasSofa, MargasSofa1, MargasSofa2],
    color: 'Karakorum 001',
    price: '4920',
    description: `The Margas series, designed to function independently or as a cohesive set, embodies a sense of familiarity and heritage. Named after Louise Liljencrantz's cherished grandmother, the series features a 3-seater sofa and matching pouf, characterized by soft yet structured proportions.`,
    productDetails: 'H: 82cm, W: 245cm, D: 113cm, Seat H: 43cm, Seat D: 72cm',
    materials:
      'Solid beech and plywood, HR foam, polyester wadding, inner upholstery of canvas.',
  },
  {
    id: 9,
    name: 'Mayor AJ6',
    featured: false,
    brand: '&Tradition',
    designer: 'Arne Jacobsen & Flemming Lassen',
    category: 'seating',
    type: 'sofa',
    img: [MayorSofa, MayorSofa1, MayorSofa2],
    color: 'orange',
    price: '6150',
    description: ` In 1939, Arne Jacobsen and Flemming Lassen won an open competition to design a new town hall, library, and theatre in Søllerød (Rudersdal). Among their designs was a wedding room for the town hall, complete with bespoke furniture—including a sofa for the couple's waiting area before the ceremony. Reflecting the solemnity of the occasion, the Mayor sofa features high vertical backs and sides. It is available in four distinct variants.`,
    productDetails:
      'H: 82cm, D: 62cm, L: 138cm, Seating H: 43cm Seating D: 50cm',
    materials:
      'Oiled Walnut, internal solid wood frame, elastic belts, HR foam, fabric',
  },
  {
    id: 10,
    name: 'Inland AV21 Lounge Chair',
    featured: false,
    brand: '&Tradition',
    designer: 'Anderssen & Voll',
    category: 'seating',
    type: 'lounge chair',
    img: [InlandClay, InlandClay1, InlandClay2],
    color: 'Clay 0011',
    price: '4390',
    description:
      'Crafted by Torbjørn Anderssen and Espen Voll, the Inland series combines architectural elegance with comfort. Originally featuring two and three-seater sofas, the series has expanded to include a lounge chair and pouf, all characterized by inviting curves and a steel-footed base that lends a floating illusion.',
    productDetails:
      'H: 66.5cm, W: 100.4cm, D: 92.7cm, Seath H: 40cm, Seat D: 63cm',
    materials:
      'Wooden frame, upholstered with fabric or leather and warm black powder coated or polished metal legs.',
  },
  {
    id: 11,
    name: 'France Chair',
    featured: false,
    brand: '&Tradition',
    designer: 'Finn Juhl',
    category: 'seating',
    type: 'lounge chair',
    img: [FanceChairBlack, FanceChairBlack2],
    color: 'black',
    price: '7950',
    description: `The France Chair, also known as the FJ 136, was initially designed for the American market in the late 1950s, delivered flat-packed. Finn Juhl's innovative approach to knock-down furniture contributed significantly to his success. Today, it comes fully assembled.
    Finn Juhl, a leading figure in twentieth-century furniture design, introduced North America to Danish Modern. Trained as an architect, he gained renown for his organic forms and expressive woodwork, aiming to infuse furniture with movement and vitality akin to sculpture.`,
    productDetails: 'H: 81cm, W: 80cm, D: 72cm, Seat H: 38cm',
    materials: 'leather, walnut',
  },
  {
    id: 12,
    name: 'Shuffle Table MH1',
    featured: true,
    brand: '&Tradition',
    designer: 'Mia Hamborg',
    category: 'table',
    type: 'side table',
    img: [ShuffleTable, ShuffleTable1, ShuffleTable2],
    color: 'Array',
    price: '805',
    description: `The Shuffle Table MH1 by &Tradition is a versatile piece of furniture designed to adapt to various uses. Its beautifully crafted wooden blocks allow for adjustable tabletop heights, making it suitable for diverse spaces. Norwegian designer Mia Hamborg has revitalized the traditional Nordic craft of woodturning by incorporating playful colors and shapes inspired by vintage wooden toys.
    Users have the freedom to determine both the placement and configuration of the Shuffle table, including its form and height. The vibrantly colored, segmented wooden leg reflects a bold and charming reinterpretation of the woodturning tradition. The Shuffle table not only captures the playful essence of old wooden toys but also embraces the Nordic tradition of democracy. It empowers users to create a custom table that fits their home perfectly, exuding joy and elegance.`,
    productDetails: 'H: 69cm, Diameter: 45cm',
    materials: 'Lacquered MDF, solid beech',
  },
  {
    id: 13,
    name: 'Rotate Table SC73',
    featured: true,
    brand: '&Tradition',
    designer: 'Space Copenhagen',
    category: 'table',
    type: 'side table',
    img: [RotateTable, RotateTable1, RotateTable2],
    color: 'Merlot',
    price: '720',
    description: `Rotate's modest design conceals its exceptional versatility. Crafted to serve a multitude of roles—from an office trolley to a bedside table or bathroom storage unit—this asymmetrical piece seamlessly integrates into any space. Equipped with unobtrusive wheels, Rotate is designed for easy maneuverability, allowing it to be effortlessly repositioned as needed.`,
    productDetails: 'H: 59cm, W: 35cm, D: 35cm',
    materials: 'Steel',
  },
  {
    id: 14,
    name: 'Palette JH9 Desk',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'table',
    type: 'desk',
    img: [PaletteDesk, PaletteDesk1, PaletteDesk2],
    color: 'black',
    price: '3600',
    description: `Inspired by Alexander Calder’s kinetic sculptures, Spanish designer Jaime Hayon has reimagined the concept of a mobile as a table, stabilized by a sleek metal armature. This design features a series of multi-tiered tables in diverse shapes, sizes, colors, and materials. The Palette desk is available in two distinct variants.`,
    productDetails: 'H: 83cm, L: 146cm, D: 62cm',
    materials: 'Powder coated steel and lacquered ash',
  },
  {
    id: 15,
    name: 'Tung JA3 Side Table',
    featured: false,
    brand: '&Tradition',
    designer: 'John Astbury',
    category: 'table',
    type: 'side table',
    img: [TungTable, TungTable1, TungTable2],
    color: 'Steel Blue',
    price: '795',
    description: `Contemporary British designer John Astbury aimed to imbue his side table, Tung, with a monolithic strength. The outcome is a compact table supported by three curved legs that evoke the architectural grandeur of ancient pillars.`,
    productDetails: 'H: 48cm, W: 38cm, D: 38cm',
    materials: 'MDF',
  },
  {
    id: 16,
    name: 'Pavilion AV17 desk',
    featured: false,
    brand: '&Tradition',
    designer: 'Anderssen & Voll',
    category: 'table',
    type: 'desk',
    img: [PavilionDesk, PavilionDesk1, PavilionDesk2],
    color: 'brown',
    price: '2150',
    description: `Inspired by the iconic Langelinie Pavilion, award-winning designers Anderssen & Voll created the Pavilion chair series, capturing a light and lyrical aesthetic. This distinctive style has now been adapted into the Pavilion desk, a compact piece designed for both office and home environments. Conceived at the start of the pandemic, the Pavilion desk thoughtfully incorporates a version with a back panel to meet the demands of home-working.`,
    productDetails: 'H: 81cm, W: 132cm, D: 66cm',
    materials: 'Steel, wood veneer, formpressed wood veneer, Forbo linoleum.',
  },
  {
    id: 17,
    name: 'Flowerpot VP9 Portable Table Lamp',
    featured: true,
    brand: '&Tradition',
    designer: 'Verner Panton',
    category: 'lighting',
    type: 'table lamp',
    img: [FlowerpotY, FlowerpotY1],
    color: 'Mustard',
    price: '375',
    description: `The portable VP9 lamp, slightly smaller than its table lamp counterpart and intentionally lightweight, features a USB charging cable for convenience. Available in contemporary colors, it adds a cozy ambiance to both indoor and outdoor spaces.
    The Flowerpot lamp became emblematic of the Flower Power movement in the late 1960s, symbolizing a departure from tradition toward a more modern, harmonious mindset. Designed by Verner Panton, a pioneering figure of his era, the Flowerpot series comprises various models, including pendants and table lamps, offered in a diverse array of colors`,
    productDetails: 'W: 16cm, H: 29.5cm',
    materials: 'Polycarbonate , steel',
  },
  {
    id: 18,
    name: 'Flowerpot VP9 Portable Table Lamp',
    featured: true,
    brand: '&Tradition',
    designer: 'Verner Panton',
    category: 'lighting',
    type: 'table lamp',
    img: [FlowerpotB, FlowerpotB1],
    color: 'Cobalt blue',
    price: '375',
    description: `The portable VP9 lamp, slightly smaller than its table lamp counterpart and intentionally lightweight, features a USB charging cable for convenience. Available in contemporary colors, it adds a cozy ambiance to both indoor and outdoor spaces.
    The Flowerpot lamp became emblematic of the Flower Power movement in the late 1960s, symbolizing a departure from tradition toward a more modern, harmonious mindset. Designed by Verner Panton, a pioneering figure of his era, the Flowerpot series comprises various models, including pendants and table lamps, offered in a diverse array of colors`,
    productDetails: 'W: 16cm, H: 29.5cm',
    materials: 'Polycarbonate , steel',
  },
  {
    id: 19,
    name: 'Flowerpot VP9 Portable Table Lamp',
    featured: true,
    brand: '&Tradition',
    designer: 'Verner Panton',
    category: 'lighting',
    type: 'table lamp',
    img: [FlowerpotR, FlowerpotR1, FlowerpotR2],
    color: 'Vermillion red',
    price: '375',
    description: `The portable VP9 lamp, slightly smaller than its table lamp counterpart and intentionally lightweight, features a USB charging cable for convenience. Available in contemporary colors, it adds a cozy ambiance to both indoor and outdoor spaces.
    The Flowerpot lamp became emblematic of the Flower Power movement in the late 1960s, symbolizing a departure from tradition toward a more modern, harmonious mindset. Designed by Verner Panton, a pioneering figure of his era, the Flowerpot series comprises various models, including pendants and table lamps, offered in a diverse array of colors`,
    productDetails: 'W: 16cm, H: 29.5cm',
    materials: 'Polycarbonate , steel',
  },
  {
    id: 20,
    name: 'Formakami JH5',
    featured: false,
    brand: '&Tradition',
    designer: 'Jamie Hayon',
    category: 'lighting',
    img: [JH5, JH5_1, JH5_2],
    type: 'pendant lamp',
    color: 'white',
    price: '420',
    description: `Jaime Hayon brings a playful twist to the traditional Asian lantern, blending Eastern and Western influences in contemporary design. Evoking centuries-old paper lanterns, which carried diverse meanings through colors, shapes, and sizes, Hayon simplifies cultural norms with a series of all-white lamps. Handcrafted with rice paper, the lamps merge various sizes and shapes, comprising three lantern versions and a table lamp adorned with black-stained oak accents.`,
    productDetails: 'W: 70cm, H: 67cm',
    materials:
      'Ivory white paper, black stained oak, 4 meter black fabric cord.',
  },
  {
    id: 21,
    name: 'Formakami JH3',
    featured: false,
    brand: '&Tradition',
    designer: 'Jamie Hayon',
    category: 'lighting',
    img: [JH3, JH3_1, JH3_2],
    type: 'pendant lamp',
    color: 'white',
    price: '410',
    description: `Jaime Hayon brings a playful twist to the traditional Asian lantern, blending Eastern and Western influences in contemporary design. Evoking centuries-old paper lanterns, which carried diverse meanings through colors, shapes, and sizes, Hayon simplifies cultural norms with a series of all-white lamps. Handcrafted with rice paper, the lamps merge various sizes and shapes, comprising three lantern versions and a table lamp adorned with black-stained oak accents.`,
    productDetails: 'W: 45cm, H: 65cm',
    materials:
      'Ivory white paper, black stained oak, 4 meter black fabric cord.',
  },
  {
    id: 22,
    name: 'Meridian Lamp',
    featured: false,
    brand: 'Ferm Living',
    designer: '',
    category: 'lighting',
    img: [MeridianLampB, MeridianLampB1, MeridianLampB2],
    type: 'table lamp',
    color: 'Black',
    price: '314.95',
    description: `The Meridian Lamp offers a versatile, dimmable lighting solution suitable for various settings. Created in collaboration with the design studio Regular Company, its sculptural form is derived from three basic geometric elements, resulting in a sleek, modern expression. With convenient charging and up to 12 hours of continuous light, this lamp ensures hassle-free illumination wherever needed.`,
    productDetails: 'W: 20cm, H: 26cm, D: 17cm',
    materials: 'Powder Coated Steel',
  },
  {
    id: 23,
    name: 'Meridian Lamp',
    featured: false,
    brand: 'Ferm Living',
    designer: '',
    category: 'lighting',
    img: [MeridianLampC, MeridianLampC1, MeridianLampC2],
    type: 'table lamp',
    color: 'Cashmere',
    price: '314.95',
    description: `The Meridian Lamp offers a versatile, dimmable lighting solution suitable for various settings. Created in collaboration with the design studio Regular Company, its sculptural form is derived from three basic geometric elements, resulting in a sleek, modern expression. With convenient charging and up to 12 hours of continuous light, this lamp ensures hassle-free illumination wherever needed.`,
    productDetails: 'W: 20cm, H: 26cm, D: 17cm',
    materials: 'Powder Coated Steel',
  },
  {
    id: 24,
    name: 'Arum Floor Lamp',
    featured: false,
    brand: 'Ferm Living',
    designer: '',
    category: 'lighting',
    img: [ArumLamp, ArumLamp1],
    type: 'floor lamp',
    color: 'Black',
    price: '1248.95',
    description: `The Arum Floor Lamp is a captivating study in contrasts, featuring an asymmetrical shade atop a slender metal stem and travertine base. Its curved, petal-shaped shade is painted white on the underside, ensuring even distribution of soft, ambient light. Perfect for illuminating a dark corner or accentuating a lounge chair with a favorite book, the adjustable shade allows for precise positioning at the ideal angle.`,
    productDetails: 'W: 25cm, H: 136cm, D: 42cm',
    materials:
      'Solid travertine base. Powder coated iron structure and aluminium lampshade. Electrical components. E12 socket. 2.6 metre fabric cord. Matte Off-white inside.',
  },
  {
    id: 25,
    name: 'Setgo Portable Table Lamp',
    featured: true,
    brand: '&Tradition',
    designer: 'Jamie Hayon',
    category: 'lighting',
    img: [SetgoLamp, SetgoLamp1, SetgoLamp2],
    type: 'table lamp',
    color: 'Maroon / Grape',
    price: '224.95',
    description: `The Seta Go table lamp takes its name from the Spanish word for mushroom, ‘seta,’ reflecting its compact, mushroom-like shape. The suffix ‘go’ highlights its portability, allowing it to be moved freely without the constraint of an electrical cord. Additional features include a subtle gold dimmer and a stylish upward curve on the brim of the lamp’s shade.`,
    productDetails: 'W: 23cm, H: 22cm',
    materials: 'Molded polycarbonate (PC), brass.',
  },
  {
    id: 26,
    name: 'Flowerpot VP12',
    featured: false,
    brand: '&Tradition',
    designer: 'Verner Panton',
    category: 'lighting',
    img: [Flowerpot, Flowerpot1, Flowerpot2],
    type: 'floor lamp',
    color: 'Silver',
    price: '1230',
    description: `Designed in close collaboration between &Tradition and the Panton family, Verner Panton’s Flowerpot floor lamp introduces a fresh dimension of illumination to homes and professional spaces. Standing at an ideal height for armchairs, sofas, and tables, this latest version offers a warm, encompassing glow in a newly adapted form.`,
    productDetails: 'W: 23cm, H: 122cm, D: 33cm',
    materials:
      'Lacquered steel and stainless steel or chrome-plated steel, textile cord.',
  },
  {
    id: 27,
    name: 'P376 KF1 Pandent Light',
    featured: false,
    brand: '&Tradition',
    designer: 'Fabricius & Kastholm',
    category: 'lighting',
    img: [Pandent, Pandent1, Pandent2],
    type: 'pendant lamp',
    color: 'Matt white',
    price: '360',
    description: `Designed in close collaboration between &Tradition and the Panton family, Verner Panton’s Flowerpot floor lamp introduces a fresh dimension of illumination to homes and professional spaces. Standing at an ideal height for armchairs, sofas, and tables, this latest version offers a warm, encompassing glow in a newly adapted form.`,
    productDetails: 'W: 47.5cm, H: 19cm',
    materials: 'Lacquered metal & fabric cord',
  },
  {
    id: 28,
    name: 'Momento Throw JH46',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [MomentoB, MomentoB1, MomentoB2],
    type: 'textile',
    color: 'Midnight Blue',
    price: '330',
    description: `The Momento throws by Jaime Hayon feature two distinct artworks, each showcasing his signature playful aesthetic. Available in two colorways—Red Dawn and Midnight Blue—these designs reflect Hayon’s aim to infuse joy and comfort into his creations.`,
    productDetails: 'W: 130cm, L: 180cm',
    materials: '100% Organic Cotton.',
  },
  {
    id: 29,
    name: 'Momento Throw JH46',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [MomentoR, MomentoR1, MomentoR2],
    type: 'textile',
    color: 'Red Dawn',
    price: '330',
    description: `The Momento throws by Jaime Hayon feature two distinct artworks, each showcasing his signature playful aesthetic. Available in two colorways—Red Dawn and Midnight Blue—these designs reflect Hayon’s aim to infuse joy and comfort into his creations.`,
    productDetails: 'W: 130cm, L: 180cm',
    materials: '100% Organic Cotton.',
  },
  {
    id: 30,
    name: 'Framed AP14',
    featured: true,
    brand: '&Tradition',
    designer: 'All the Way to Paris',
    category: 'objects',
    img: [Framed, Framed1, Framed2],
    type: 'textile',
    color: 'Plum',
    price: '800',
    description: `Crafted from 100% New Zealand wool, the Framed rug adds subtle color accents without overwhelming a space. Designed by All the Way to Paris, it combines two rug-making techniques: a vibrant, tufted border contrasts with a calm, monochromatic kilim center. This playful interplay of tones and textures creates a striking aesthetic while adding depth to its name.`,
    productDetails: 'W: 90cm, L: 240cm',
    materials: '100% Wool.',
  },
  {
    id: 31,
    name: 'The Moor AP18',
    featured: false,
    brand: '&Tradition',
    designer: 'All the Way to Paris',
    category: 'objects',
    img: [Moor, Moor1, Moor2],
    type: 'textile',
    color: 'Golden Brown',
    price: '1420',
    description: `Hand-woven in India, The Moor collection now features opulent velvet-like textures with the addition of cotton fringing, enhancing its tactile appeal. Made from a blend of New Zealand wool, this collection is designed to ground a room and impart a sense of closeness to any space it inhabits.`,
    productDetails: 'W: 170cm, L: 240cm',
    materials: '85% New Zealand Wool, 15% Viscose, 100% Cotton fringe',
  },
  {
    id: 32,
    name: 'Momento Vase JH41',
    featured: true,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [JH41, JH41_1],
    type: 'vase',
    color: 'Emerald',
    price: '220',
    description: `The sculptural shapes of the Momento Vases echo the forms found in Jaime Hayon's paintings, showcasing a strong and playful graphic identity. The JH40, available in soft Cream, and the JH41, in bold Emerald green, are chosen for their versatility and connection to the fresh hues of flora. Beyond their aesthetic appeal, the slim-neck design encourages thoughtful selection when arranging flowers, promoting mindfulness in bouquet creation.`,
    productDetails: 'W: 31.8cm, H: 30cm, D: 18cm',
    materials: 'Ceramic.',
  },
  {
    id: 33,
    name: 'Momento Vase JH40',
    featured: true,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [JH40, JH40_1],
    type: 'vase',
    color: 'Cream',
    price: '180',
    description: `The Momento Vases feature sculptural shapes reminiscent of Jaime Hayon’s paintings, displaying a strong and playful graphic identity. The two distinct forms are equally iconic: the JH40 is available in soft Cream, and the JH41 in bold Emerald green—both colors chosen for their versatility and their connection to the fresh hues of flora. Beyond their visual appeal, the slim-neck design of the Momento vases encourages selective flower arrangement, fostering mindfulness when creating a bouquet.`,
    productDetails: 'W: 19.3cm, H: 28.8cm, D: 15.2cm',
    materials: 'Ceramic.',
  },
  {
    id: 34,
    name: 'Verso Tabel Vase',
    featured: false,
    brand: 'Ferm Living',
    designer: '',
    category: 'objects',
    img: [Verso, Verso1, Verso2],
    type: 'vase',
    color: 'Terracotta',
    price: '178.95',
    description: `Evoking classic shapes from traditional pottery, the Verso Table Vase features an irregular, feminine form with a pair of distinct, gracefully curved handles that add a modern twist to its timeless design. Use it to display your favorite flora or as a standalone statement piece.`,
    productDetails: 'W: 27.5cm, H: 27cm, D: 18cm',
    materials: 'Glazed Stoneware.',
  },
  {
    id: 35,
    name: 'White Cara Clock',
    featured: false,
    brand: 'LEMNOS',
    designer: 'Riki Watanabe',
    category: 'objects',
    img: [Cara, Cara1],
    type: 'clock',
    color: 'White',
    price: '189.95',
    description: `- The large-scale Cara clock features a highly visible face paired with a slender, simple silhouette. Its extra-long minute hand creates a light, dynamic design, while the stocky orange hour hand adds bold contrast and visual interest.
    Founded in 1947 in Toyama Prefecture, Japan, Lemnos Inc. started as a brass casting manufacturer. In 1966, they began supplying key parts to Seiko Clock Co. and by 1980, started collaborating with renowned designers to produce fine clocks. Lemnos partners with famous designers and skilled craftsmen to create high-quality, timeless design objects that maintain their value over time.`,
    productDetails: 'W: 32cm, D: 5cm',
    materials: 'ABS Resin and Glass.',
  },
  {
    id: 36,
    name: 'Riki Steel Clock White',
    featured: true,
    brand: 'LEMNOS',
    designer: 'Riki Watanabe',
    category: 'objects',
    img: [Riki, Riki1],
    type: 'clock',
    color: 'White',
    price: '239.95',
    description: `The Riki Steel Clock stands out with its bold black-and-white design, featuring a numerical index that ensures high visibility of the twelve serifed figures, complemented by rectangular clock hands. Encased in a sleek metal body with a subtle white matte finish, this clock blends functionality with elegant aesthetics.
    Established in 1947 in Toyama Prefecture, Japan, Lemnos Inc. began as a brass casting manufacturer. By 1966, they were supplying key parts to Seiko Clock Co., and in 1980, they started collaborating with notable designers to create fine clocks. Lemnos partners with renowned designers and skilled craftsmen to produce high-quality, timeless design objects that retain their value over time.`,
    productDetails: 'W: 20.4cm, D: 6cm',
    materials: 'Steel, ABS Resin, Glass.',
  },
  {
    id: 37,
    name: 'Momento Jug JH38',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [Jug, Jug1, Jug2],
    type: 'tableware',
    color: 'Polished Stainless Steel',
    price: '210',
    description: `The Momento Jug represents the culmination of years of product research aimed at crafting a spill-resistant vessel with an ideal pouring form. Offered in two variants—Polished Stainless Steel and Ivory—the Momento Jug has a capacity of up to 1 liter.`,
    productDetails: 'W: 11.6cm, H: 24cm, D: 21.5cm',
    materials: 'Polished Stainless Steel',
  },
  {
    id: 38,
    name: 'Momento Candleholder JH39',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [CandleholderR, CandleholderR1],
    type: 'tableware',
    color: 'Poppy Red',
    price: '85',
    description: `The Momento Candleholder celebrates the timeless form of classic candleholders, originally designed for portability from room to room. Handcrafted with precision by artisans in Portugal through slip-casting and glazing, the JH39 Candleholder is available in four colors inspired by Hayon’s artwork. Azure and Poppy Red offer vibrant, statement hues, while Ivory and Red Brown introduce rich, sophisticated tones to interiors.`,
    productDetails: 'W: 14.2cm, H: 8.5cm, D: 11.8cm',
    materials: 'Ceramic',
  },
  {
    id: 39,
    name: 'Momento Candleholder JH39',
    featured: false,
    brand: '&Tradition',
    designer: 'Jaime Hayon',
    category: 'objects',
    img: [CandleholderB, CandleholderB1],
    type: 'tableware',
    color: 'Azure',
    price: '85',
    description: `The Momento Candleholder celebrates the timeless form of classic candleholders, originally designed for portability from room to room. Handcrafted with precision by artisans in Portugal through slip-casting and glazing, the JH39 Candleholder is available in four colors inspired by Hayon’s artwork. Azure and Poppy Red offer vibrant, statement hues, while Ivory and Red Brown introduce rich, sophisticated tones to interiors.`,
    productDetails: 'W: 14.2cm, H: 8.5cm, D: 11.8cm',
    materials: 'Ceramic',
  },
  {
    id: 40,
    name: 'Matin Flush Mount Lamp',
    featured: false,
    brand: 'HAY',
    designer: 'Inga Sempé',
    category: 'lighting',
    img: [MatinLamp, MatinLamp1],
    type: 'pendant lamp',
    color: 'peach',
    price: '245',
    description: `Inga Sempé is celebrated for her designs that exude a delicate touch, and her Matin Flushmount Lamp is no exception. This versatile lamp can be mounted on either a wall or ceiling, offering a warm, inviting glow whether it's on or off. The lamp features a pleated PVC-laminated cotton shade and comes with a painted steel bracket for easy installation. It's hardwired and compatible with dimmer switches and dimmable LED bulbs (not included). The Matin Flushmount Lamp is a key piece in the Matin lighting collection, perfect for adding elegance to any space.`,
    productDetails: 'H: 17.78cm D: 48.26cm',
    materials: 'CPVC-laminated cotton shade, Painted steel bracket',
  },
  {
    id: 41,
    name: 'Pao Portable Lamp',
    featured: true,
    brand: 'HAY',
    img: [PaoLamp, PaoLamp1, PaoLamp2],
    designer: 'Naoto Fukasawa',
    category: 'lighting',
    type: 'table lamp',
    color: 'red',
    price: '195',
    description: `Inspired by the mushroom-like forms of illuminated Mongolian Pao tents, Japanese designer Naoto Fukasawa crafted the Pao Collection. The Pao Portable Lamp, featuring a glossy polycarbonate shade, emits a soft, ambient glow reminiscent of candlelight, without the risk. This compact, modern lamp is lightweight, battery-operated, and can be easily moved from room to room. It includes a G4 LED bulb and is UL listed for safety. Available in four colors, the lamp’s rechargeable battery provides up to 10 hours of light on a single charge. It's a perfect blend of function and design.`,
    productDetails: 'H: 22.86cm  D: 22.86cm',
    materials: 'Polycarbonate base and shade',
  },
];
